<!-- AI GENERATED - REVIEW, ADO 7841953 -->
<span title="{{ currencyName$ | async }}">{{ currencyCode$ | async }}</span>
<span
  title="{{ currencyCode$ | async }} {{ amount$ | async | negativeParentheses: '1.2-10' }}"
>
  @if (roundingBehavior === "none") {
    {{ amount$ | async | negativeParentheses: "1.2-10" }}
  } @else {
    {{ amount$ | async | negativeParentheses: digitsInfo }}
  }
</span>
